/**
 * Centralized event bus to avoid circular dependencies
 * This singleton pattern ensures we have a single instance of the event bus
 */
import mitt from 'mitt';

// Create a typed event emitter
type Events = {
  page_view: any;
  refreshToken: any;
  [key: string]: any;
};

const emitter = mitt<Events>();

// Export a singleton instance
export default {
  $on: (event: string, callback: any) => emitter.on(event, callback),
  $off: (event: string, callback: any) => emitter.off(event, callback),
  $emit: (event: string, payload?: any) => emitter.emit(event, payload)
};
